import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateShareFromCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars['ID']['input'];
  colorTheme?: Types.InputMaybe<Types.ColorThemeEnum>;
  expiration?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  generatePassphrase?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  downloadingEnabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CreateShareFromCollectionMutation = { __typename?: 'Mutation', createShareFromCollection?: { __typename?: 'CreateShareFromCollectionPayload', share?: { __typename?: 'AdHocAssetsShare', id: string, colorTheme: Types.ColorThemeEnum, enabled: boolean, expiration?: string | null, expiresIn?: number | null, name: string, url?: string | null } | { __typename?: 'CollectionShare', id: string, colorTheme: Types.ColorThemeEnum, enabled: boolean, expiration?: string | null, expiresIn?: number | null, name: string, url?: string | null, collection?: { __typename?: 'Collection', id: string, name: string } | null } | null, metadata?: { __typename?: 'CreateShareFromCollectionMetadata', passphraseGenerated: boolean } | null } | null };


export const CreateShareFromCollection = /*#__PURE__*/ gql`
    mutation CreateShareFromCollection($collectionId: ID!, $colorTheme: ColorThemeEnum, $expiration: DateTime, $generatePassphrase: Boolean, $downloadingEnabled: Boolean) {
  createShareFromCollection(
    input: {collectionId: $collectionId, settings: {colorTheme: $colorTheme, expiration: $expiration, generatePassphrase: $generatePassphrase, downloadingEnabled: $downloadingEnabled}}
  ) {
    share {
      ... on CollectionShare {
        collection {
          id
          name
        }
      }
      id
      colorTheme
      enabled
      expiration
      expiresIn
      name
      url
    }
    metadata {
      passphraseGenerated
    }
  }
}
    ` as unknown as DocumentNode<CreateShareFromCollectionMutation, CreateShareFromCollectionMutationVariables>;

          

          export const useCreateShareFromCollectionMutation = (options?:MutationHookOptions<CreateShareFromCollectionMutation, CreateShareFromCollectionMutationVariables>) => useMutation(CreateShareFromCollection, options);
          

          export type CreateShareFromCollectionMutationOptions = MutationHookOptions<CreateShareFromCollectionMutation, CreateShareFromCollectionMutationVariables>;

          

          export type CreateShareFromCollectionMutationResult = ReturnType<typeof useCreateShareFromCollectionMutation>[1];

          
